import type { TWidgetMetaInfo } from '@tenorlab/vue-dashboard'
import { Bookmark as ComponentIcon } from 'lucide-vue-next'
import { markRaw } from 'vue'

export const WidgetRecentProjectsMeta: TWidgetMetaInfo = {
  name: 'Projects',
  categories: ['Widget'],
  icon: markRaw(ComponentIcon),
  description: 'Display most recent projects',
  externalDependencies: [],
}
